import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
}

export const SEO = ({
  title = 'Scribelate - Learn Languages Through Podcasts',
  description = 'Master Spanish, English, and Japanese through podcast-based learning. Control playback speed, create audio segments, and build vocabulary with authentic content.',
  keywords = 'language learning, podcast learning, Spanish learning, Japanese learning, English learning',
  canonical,
  ogImage = 'https://scribelate.com/og-image.png',
}: SEOProps) => {
  // If title already includes "Scribelate" or if no custom title is provided, use it as-is
  // Otherwise append " | Scribelate" to page-specific titles
  const fullTitle = title.includes('Scribelate') ? title : `${title} | Scribelate`;
  const canonicalUrl = canonical || typeof window !== 'undefined' ? window.location.href : 'https://scribelate.com/';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
